import { render } from "./Wallpaper.vue?vue&type=template&id=dc4c25d4&scoped=true"
import script from "./Wallpaper.vue?vue&type=script&lang=js"
export * from "./Wallpaper.vue?vue&type=script&lang=js"

import "./Wallpaper.vue?vue&type=style&index=0&id=dc4c25d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dc4c25d4"

export default script